import { Immutable } from "immer";
import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type IProps = Immutable<{
    id: string;
    centered?: boolean;
    className?: string;
    detailClassName?: string;
    menu?: React.ReactNode;
    menuLabel?: string;
    children: React.ReactNode;
}>;

export const OrderSupportLayout = (props: IProps): React.JSX.Element => {
    const Menu = props.menuLabel ? "nav" : "div";
    return (
        <section
            id={props.id}
            className={concatClassNames([
                styles.orderSupport,
                props.centered ? styles.orderSupportContentCentered : null,
                props.className,
            ])}
        >
            <div className="main-container">
                {props.menu ? (
                    <Menu
                        className={styles.menuContainer}
                        aria-label={props.menuLabel}
                    >
                        {props.menu}
                    </Menu>
                ) : null}
                <div
                    className={concatClassNames([
                        styles.detailContainer,
                        props.detailClassName,
                    ])}
                >
                    {props.children}
                </div>
            </div>
        </section>
    );
};
